import { buildGetApiClient } from '@b-stock/fe-core/bstock-next/queries'
import { EuTaxApi } from '@b-stock/listing-api-client'

// Mirror of `getCanadianTaxClient`: same `LISTINGS` host, different
// controller. Consumes `EuTaxApi` (svc/listing under FP-2643 —
// `GET /v1/eu-tax/listings/:id/running-estimate` and
// `.../max-exposure`) for FP-3095's bid-time VAT UI.
const getEuTaxClient = buildGetApiClient('LISTINGS', EuTaxApi)

export default getEuTaxClient
